export const getRefundViewAction = "MEMEBER_SERVICE/VIEW/REFUND";
export const getRefundViewSuccessAction = "MEMEBER_SERVICE/VIEW/REFUND/SUCCESS";
export const getRefundViewFailAction = "MEMEBER_SERVICE/VIEW/REFUND/FAIL";
export const getRefundViewResetAction = "MEMEBER_SERVICE/VIEW/REFUND/RESET";
